import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LandingmobileserviceService {
  public showMobileMenu = true;
  constructor() {}
}
